import CryptoJS from './aes';
import CryptoJS1 from './pbkdf2'; 

// const secret=require('../../../Utils/secretKeys.js')
// function genPassword(){
//     let chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//     let passwordLength = 12;
//     let password = "";
//     for (var i = 0; i <= passwordLength; i++) {
//         let randomNumber = Math.floor(Math.random() * chars.length);
//         password += chars.substring(randomNumber, randomNumber +1);
//        }
//    return password
// }
function getString(){
    return "bXl2ZXJ5c2VjcmV0cGhyYXNl"
}
function encryptChatData(chat) {
    if (!window['encryptChat']){
        return chat;
    }

    let passphrase = '',
        salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex),
        iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex),
        key = CryptoJS1.PBKDF2(atob(getString()), CryptoJS.enc.Hex.parse(salt), {
            keySize: 4,
            iterations: 100
        }),
        encrypted = CryptoJS.AES.encrypt(chat, key, {
            iv: CryptoJS.enc.Hex.parse(iv),

        });
    encrypted = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    var encryptedChat = (iv + "::" + salt + "::" + encrypted);
    encryptedChat = btoa(encryptedChat);
    return (encryptedChat)
}

export default encryptChatData;